/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tracking_BatteryInputs */

const vi_tracking_battery = /** @type {(inputs: Tracking_BatteryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pin`)
};

/**

* @param {Tracking_BatteryInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tracking_battery = /** @type {((inputs?: Tracking_BatteryInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tracking_BatteryInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tracking_battery(inputs)
});